import { jsx as _jsx } from "react/jsx-runtime";
import AutosizeInput from 'react-input-autosize';
import { styled } from 'styled-components';
const Wrapper = styled.div `
  position: relative;
  height: 38px;
`;
const Container = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  > * {
    display: block !important;
  }
  input {
    min-width: calc(100% - 24px);
    border-radius: 4px;
    border: solid 1px ${({ theme }) => theme.colors.grey30_1};
    height: 20px;
    padding: 8px 12px;
    font-size: 14px;
    font-family: CircularXXWeb, Roboto, sans-serif;
    color: ${({ theme }) => theme.colors.black_1};
    resize: none;
    box-sizing: border-box;
    &:not(:focus) {
      max-width: calc(100% - 24px);
      text-overflow: ellipsis;
    }
    &:focus {
      position: relative;
      z-index: 1;
      border-color: ${({ theme }) => theme.colors.main};
      outline: none;
      box-shadow: 0 0 0 1px ${({ theme }) => theme.colors.main};
    }
    transition: all 100ms;
    background-color: ${({ theme }) => theme.colors.grey00_7};

    &::placeholder {
      color: ${({ theme }) => theme.colors.grey70_1};
    }

    &[disabled],
    &[readonly] {
      background-color: ${({ theme }) => theme.colors.grey05_3};
      border-color: ${({ theme }) => theme.colors.grey30_2};
    }

    &[disabled] {
      color: ${({ theme }) => theme.colors.grey100_2};
      &::placeholder {
        color: ${({ theme }) => theme.colors.grey100_2};
      }
    }

    &:not([disabled], [readonly], :focus):hover {
      border-color: ${({ theme }) => theme.colors.grey70_1};
    }
  }
`;
const FlexibleInput = (props) => {
    const { className = '', input, meta: _meta, ...other } = props;
    return (_jsx(Wrapper, { children: _jsx(Container, { children: _jsx(AutosizeInput, { className: className, ...input, ...other }) }) }));
};
export { FlexibleInput };
